import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingShopifyAppExplanation.scss';

import BrandOnboardingProgressBar from '../BrandOnboardingProgressBar';
import BrandOnboardingShopifyFAQ from '../BrandOnboardingShopifyFAQ';

const BrandOnboardingShopifyAppExplanation = props => {
  const shopifyAppPerks = [
    {
      title: 'Automated Lookbooks',
      description:
        'Powers automated gifting, so you don’t have to manually fulfill creator orders. Note that creating this app is a required step if your team plans to use ShopMy’s automated lookbook capabilities for gifting fulfillment.'
    },
    {
      title: 'Live Product Feed Sync',
      description:
        'Automatically keeps your product catalog up to date within ShopMy’s creator platform for easier promotion and streamlined gifting selections.'
    },
    {
      title: 'Order Tracking & Post-Purchase Updates',
      description:
        'If you’re tracking on ShopMy’s network, ensures accurate commission tracking by reporting cancellations and refunds—so you’re never overpaying on creator commissions.'
    }
  ];

  return (
    <div className='brand-onboarding-shopify-explanation-panel-outer'>
      <div className='brand-onboarding-shopify-explanation-panel-inner'>
        <div className='brand-onboarding-split-container-outer'>
          <div className='brand-onboarding-split-container-inner'>
            <div className='brand-onboarding-graphic-container-outer'>
              <div className='brand-onboarding-graphic-container-inner content-start'>
                <BrandOnboardingShopifyFAQ />

                <BrandOnboardingProgressBar
                  goToPanel={props.goToPanel}
                  sections={props.sections}
                  activeSectionName={props.activeSectionName}
                  activePanelName={props.activePanelName}
                />
              </div>

              <div className='brand-onboarding-graphic-background blur'>
                <img className='brand-onboarding-graphic-background-image' src={props.backgroundImage} alt='name panel graphic' />
                <div className='brand-onboarding-graphic-background-overlay'></div>
              </div>
            </div>

            <div className='brand-onboarding-input-container-outer'>
              <div className='brand-onboarding-input-container-number-marker'>{props.panelNumber}</div>

              <div className={cn('brand-onboarding-input-container-inner', { isLoading: props.isLoading })}>
                <div className='brand-onboarding-title-text'>Unlock Key Features with the ShopMy Custom App</div>
                <div className='brand-onboarding-subtitle-text'>
                  A simple setup that saves your team time and resources. On our next page we’ll walk you through installing the ShopMy app. This app
                  unlocks key features that make working in your account easier and more efficient, including:
                </div>

                <div className='brand-onbaording-shopify-app-explanation-perks-list'>
                  {shopifyAppPerks.map((perk, index) => (
                    <div key={index} className='brand-onboarding-shopify-app-explanation-perk-item'>
                      <div className='brand-onboarding-shopify-app-explanation-perk-item-number'>{index + 1}</div>
                      <div className='brand-onboarding-shopify-app-explanation-perk-item-text'>
                        <div className='brand-onboarding-input-label'>{perk.title}</div>
                        <div className='brand-onboarding-input-sublabel'>{perk.description}</div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className='brand-onboarding-input-disclaimer'>
                  <b>Note:</b> This is not a standard Shopify App Store app. It will be set up via Shopify’s <b>Custom Apps</b> feature. Instructions
                  for setup can be found by hitting “Next”.
                </div>
                <div className='brand-onboarding-pagination-buttons'>
                  <button className='brand-onboarding-button stretch' onClick={() => props.goToPreviousPanel()}>
                    Back
                  </button>
                  <button className='brand-onboarding-button stretch primary' onClick={() => props.goToNextPanel()}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandOnboardingShopifyAppExplanation.propTypes = {
  updateBrandOnboardingObject: PropTypes.func.isRequired,

  goToPreviousPanel: PropTypes.func.isRequired,
  goToNextPanel: PropTypes.func.isRequired
};

export default BrandOnboardingShopifyAppExplanation;
